import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import ContentWrapper from '../Layout/ContentWrapper';
import { Button, Col, Grid, Input, Panel, Row } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { Selection } from '../Common/selection';
import _ from 'lodash';
import {
  createVendorPriceItem,
  deleteVendorPriceItem, fetchVendorPriceTableDetail,
  fetchVendorProducts,
  updateVendorPriceItem, vendorPriceTableSubmit
} from '../../actions/vendors_actions';
import DatePicker from '../Common/datePicker';
import moment from 'moment';
import InputField from '../Common/inputField';
class PriceTableFormModalContainer extends Component {
  constructor() {
    super();
  }
  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.currentVendor && nextProps.currentVendor !== this.props.currentVendor) {
      this.props.fetchVendorProducts(nextProps.currentVendor.Vendor_id);
    }
  }
  componentDidMount() {
    if (this.props.editRow && this.props.editRow.vendor_product_price_id) {
      this.props.fetchVendorPriceTableDetail(this.props.editRow.vendor_product_price_id);
    }
    if (this.props.currentVendor) {
      this.props.fetchVendorProducts(this.props.currentVendor.Vendor_id);
    }
  }

  handleFormSubmit = _.debounce((formProps) => {
    const { onConfirm, vendorPriceTableSubmit } = this.props;
    vendorPriceTableSubmit(this.props.currentVendor.Vendor_id, formProps, () => {
      onConfirm && onConfirm(true);
    });
  }, 200)

  handleCancel = () => {
    const { onCancel } = this.props;
    onCancel && onCancel(true);
  }
  render() {
    const { handleSubmit, vendorProducts } = this.props;
    const buttonGroupStyle = {position: 'absolute', bottom: '15px', left: '15px', right: '15px', textAlign: 'center'};
    return (
      <ContentWrapper style={{height: '90%'}}>
        <form autoComplete="off" method="get" action="#" onSubmit={handleSubmit(formProps => {
          this.handleFormSubmit(formProps)
        })} style={{height: '100%'}}>
          <Panel style={{height: '100%'}}>
            <Grid id="vendor-price-table-form" style={{width: '100%'}}>
              <Row style={{marginBottom: '5px'}}>
                <Col xs={6}>
                  <div className="form-group">
                    <label className="col-xs-3"><Translate value="product" /></label>
                    <div id="product-id-dropdown" className="col-xs-8">
                      <Field name={'Product_id'} matchPos="any" component={Selection} options={vendorProducts} searchable />
                    </div>
                  </div>
                </Col>
                <Col xs={6}>
                  <div className="form-group">
                    <label className="col-xs-3"><Translate value="quote_date" /></label>
                    <div id="quote-date-picker" className="col-xs-8">
                      <Field name="Quote_date" component={DatePicker} />
                    </div>
                  </div>
                </Col>
              </Row>
              <Row style={{marginBottom: '5px'}}>
                <Col xs={6}>
                  <div className="form-group">
                    <label className="col-xs-3"><Translate value="min_qty_vendor" /></label>
                    <div id="moq-input" className="col-xs-8">
                      <Field name="MOQ" component={InputField} type={'number'} decimal />
                    </div>
                  </div>
                </Col>
                <Col xs={6}>
                  <div className="form-group">
                    <label className="col-xs-3"><Translate value="lead_time" /></label>
                    <div id="lead-time" className="col-xs-8">
                      <Field name="Lead_time" component={InputField} type={'number'} decimal />
                    </div>
                  </div>
                </Col>
              </Row>
              <Row style={{marginBottom: '5px'}}>
                <Col>
                  <PriceListRedux />
                </Col>
              </Row>
              <Row style={{marginBottom: '5px'}}>
                <Col xs={12}>
                  <div className="form-group">
                    <label className="col-xs-2"><Translate value="quote_validity" /></label>
                    <div id="quote-validity" className="col-xs-2">
                      <Field name="Quote_Validity" component={DatePicker} />
                    </div>
                  </div>
                </Col>
              </Row>
              <Row style={{marginBottom: '5px'}}>
                <Col xs={12}>
                  <div className="form-group">
                    <label className="col-xs-2"><Translate value="notation" /></label>
                    <div id="lead-time" className="col-xs-8">
                      <Field name="Notation" component={"textarea"} rows={4} cols={90}/>
                    </div>
                  </div>
                </Col>
              </Row>
            </Grid>
            <div className="form-group" style={buttonGroupStyle}>
              <Button bsStyle="success" style={{marginRight: '30px'}} onClick={handleSubmit(this.handleFormSubmit)} disabled={this.props.isLoadingVendorPriceTableDetail}>
                <i className="fa fa-save" />&nbsp;<Translate value="save"/></Button>
              <Button onClick={this.handleCancel}><Translate value="cancel"/></Button>
            </div>
          </Panel>
        </form>
      </ContentWrapper>
    )
  }
}

class PriceList extends Component {
  constructor() {
    super();
    this.state = {
      activeIndex: null
    }
  }
  
  handleClick = index => {
    this.setState({
      activeIndex: index === this.state.activeIndex ? null : index
    });
  }
  handleDelete = index => {
    this.props.deleteVendorPriceItem(index);
  }
  handleConfirm = state => {
    const {index, ...item} = state;
    if (index !== undefined && index !== null) {
      this.props.updateVendorPriceItem(index, item);
    } else {
      this.props.createVendorPriceItem(item);
    }
    this.setState({
      activeIndex: null,
    })
  }
  render() {
    const { priceList } = this.props
    return (
        <div style={{marginLeft: '15px'}}>
          <Row>
            <Col xs={3}>
              <label className="col-xs-12"><Translate value={'min_qty'}/></label>
            </Col>
            <Col xs={3}>
              <label className="col-xs-12"><Translate value={'max_qty'}/></label>  
            </Col>
            <Col xs={3}>
              <label className="col-xs-12"><Translate value={'price'}/></label>
            </Col>
            <Col xs={3}>
              <label className="col-xs-12"><Translate value={'action'}/></label>
            </Col>
          </Row>
          {priceList.map((item, index) => (
              <Row key={index} style={{marginBottom: '5px'}}><PriceListItem 
                  data={item}
                  index={index}
                  editing={this.state.activeIndex === index}
                  onClick={this.handleClick}
                  onDelete={this.handleDelete}
                  onConfirm={this.handleConfirm}
              /></Row>))}
          <Row><PriceListItem editing onConfirm={this.handleConfirm}/></Row>
        </div>
    )
  }
}
const PriceListRedux = connect(state => ({
  priceList: state.vendors.priceTable.currentVendorPrice.priceList
}), {
  updateVendorPriceItem, 
  createVendorPriceItem, 
  deleteVendorPriceItem
})(PriceList);

class PriceListItem extends Component {
  constructor() {
    super();
    this.state = {
      index: null,
      minQty: '',
      maxQty: '',
      price: '',
    }
  }
  componentDidMount() {
    if (this.props.data) {
      this.setState({
        index: this.props.index,
        minQty: this.props.data.minQty,
        maxQty: this.props.data.maxQty,
        price: this.props.data.price
      })
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.data && nextProps.data !== this.props.data) {
      this.setState({
        index: nextProps.index,
        minQty: nextProps.data.minQty,
        maxQty: nextProps.data.maxQty,
        price: nextProps.data.price
      })
    }
  }

  handleChange = e => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  }
  handleConfirm = () => {
    const { onConfirm } = this.props;
    onConfirm && onConfirm(this.state);
    if (this.state.index === undefined || this.state.index === null) {
      this.setState({
        index: null,
        minQty: '',
        maxQty: '',
        price: '',
      });
    }
  }
  handleDelete = () => {
    if (this.state.index !== undefined && this.state.index !== null) {
      this.props.onDelete && this.props.onDelete(this.state.index)
    }
  }
  
  handleClick = () => {
    if (this.state.index !== undefined && this.state.index !== null) {
      this.props.onClick && this.props.onClick(this.state.index)
    }
  }
  
  render() {
    const { editing } = this.props;
    return (
      <div className="form-group" style={{cursor: 'pointer'}}>
        <div className="col-xs-3" onClick={this.handleClick}>
          {
            editing 
              ? <Input type={'text'} name={'minQty'} value={this.state.minQty} onClick={e => e.stopPropagation()} onChange={this.handleChange}/> 
              : <div className="col-xs-12">{this.state.minQty}</div> 
          }
        </div>
        <div className="col-xs-3" onClick={this.handleClick}>
          {
            editing
             ? <Input type={'text'} name={'maxQty'} value={this.state.maxQty} onClick={e => e.stopPropagation()} onChange={this.handleChange} /> 
             : <div className="col-xs-12">{this.state.maxQty}</div>
          }
        </div>
        <div className="col-xs-3" onClick={this.handleClick}>
          {
            editing
              ? <Input type={'text'} name={'price'} value={this.state.price} onClick={e => e.stopPropagation()} onChange={this.handleChange} onKeyPress={e => e.charCode === 13 && this.handleConfirm()} />
              : <div className="col-xs-12">{this.state.price}</div>
          }
        </div>
        <div className="col-xs-2">
          {
            editing
                ? <Button onClick={this.handleConfirm}><Translate value={'ok_vendor'} /></Button>
                : <Button bsStyle="danger" onClick={this.handleDelete}><Translate value={'del'} /></Button>
          }
        </div>
      </div>
    )
  }
}
const validate = values => {
  const errors = {};
  if (!values.Product_id || !values.Product_id.value) {
    errors.Product_id = 'Please select a product';
  }
  return errors
}
const PriceTableFormModal = reduxForm({
  form: 'priceTableForm',
  enableReinitialize: true,
  validate,
  touchOnChange: true,
  touchOnBlur: false,
})(PriceTableFormModalContainer);
const mapStateToProps = state => {
  return {
    currentVendor: state.vendors.currentVendor,
    initialValues: state.vendors.priceTable.currentVendorPrice,
    vendorProducts: state.vendors.vendorProducts.map(product => ({label: product.product_num + ', ' + product.name, value: product.id})),
    isLoadingVendorProducts: state.vendors.isLoadingVendorProducts,
    isLoadingVendorPriceTableDetail: state.vendors.isLoadingVendorPriceTableDetail,
  }
}
export default connect(mapStateToProps, {fetchVendorProducts, vendorPriceTableSubmit, fetchVendorPriceTableDetail})(PriceTableFormModal)



// WEBPACK FOOTER //
// ./master/jsx/components/Vendors/priceTableFormModal.jsx